import React, { Component } from 'react';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import { appService } from '../../_services';
import DocumentMeta from 'react-document-meta';
import ReactGA from 'react-ga';
let filesArray = [], formIsValid = true, parameters = "";//Start:Pradip Lalvani -Email

export class Feedback extends Component {
    displayName = Feedback.name

    constructor(props) {
        super(props);
        this.state = { content: '' };
        this.state = {
            feedback: {
                subject: '',
                category: '',
                firstname: '',
                lastname: '',
                organization: '',
                country: '',
                product: '',
                description: '',
                email: '', JobTitle: '', Phone: '', iAgree: false
            },
            consent: false,
            receive_info: false,
            filenames: [],
            files: [],
            submitted: false, showtext: true, errors: {}
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this)
        this.setFile = this.setFile.bind(this);
    }

    componentDidMount() {
        ReactGA.initialize(
            [
                {
                    trackingId: 'UA-2905701-8',
                    gaOptions: { name: 'tracker1' }
                },
                {
                    trackingId: 'UA-72849501-2',
                    gaOptions: { name: 'tracker2' }
                }
            ],
            { alwaysSendToDefaultTracker: false }
        );

        ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], "Kluwer Law Online - Feedback");
    }

    validateForm() {

        let fields = this.state.feedback;
        let errors = {};
        let formIsValid = true;

        if (!fields["subject"]) {
            formIsValid = false;
            errors["subject"] = "* Required field";
        }

        if (!fields["firstname"]) {
            formIsValid = false;
            errors["firstname"] = "* Required field";
        }
       
        if (!fields["lastname"]) {
            formIsValid = false;
            errors["lastname"] = "* Required field";
        }

        if (!fields["organization"]) {
            formIsValid = false;
            errors["organization"] = "* Required field";
        }

        if (!fields["JobTitle"]) {
            formIsValid = false;
            errors["JobTitle"] = "* Required field";
        }

        if (!fields["email"]) {
            formIsValid = false;
            errors["email"] = "* Required field";
        }
        else if (typeof fields["email"] !== "") {
            //regular expression for email validation
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(fields["email"])) {
                formIsValid = false;
                errors["email"] = "* Please enter a valid email address";
            }
        }
      
        if (!fields["country"]) {
            formIsValid = false;
            errors["country"] = "* Required field";
        }

        if (!fields["category"]) {
            formIsValid = false;
            errors["category"] = "* Required field";
        }

        if (!fields["description"]) {
            formIsValid = false;
            errors["description"] = "* Required field";
        }

        if (!fields["iAgree"]) {
            formIsValid = false;
            errors["iAgree"] = "* Permission required to send message";
        }

        this.setState({
            errors: errors
        });

        return formIsValid;

    }

    handleChange(event) {

        if (event.target.type == "checkbox") {
            if (event.target.name == "receive_info") {
                this.setState({ receive_info: event.target.checked });
            }
            else {
                this.setState({ consent: event.target.checked });
            }

            const { feedback } = this.state;
            this.setState({
                feedback: {
                    ...feedback,
                    iAgree: event.target.checked
                }
            }); 
        }
        else {
            const { name, value } = event.target;
            const { feedback } = this.state;

            this.setState({
                feedback: {
                    ...feedback,
                    [name]: value
                }
            });
        }
       
    }

    setFile(e) {
        const {files, filenames} = this.state;
        files.push(e.target.files[0])
        filenames.push(e.target.files[0].name);
        this.setState({ files: files});
        this.setState({ filenames: filenames});
        // console.log(files);
        let form = new FormData();
        form.append('file', e.target.files[0]);
        // for (var index = 0; index < files.length; index++) {
        //   var element = files[index];
        //   form.append('file', element);
        // }
        appService.Post('Email/UploadFiles',form).then((x)=>{
            //console.log(x);
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        const { feedback, submitted, filenames, files, receive_info, consent } = this.state;    
        if (this.validateForm()) {
            if (consent == true) {

                parameters = {
                    Subject: feedback.subject,
                    Category: feedback.category,
                    FirstName: feedback.firstname,
                    LastName: feedback.lastname,
                    Organization: feedback.organization,
                    Country: feedback.country,
                    Product: feedback.product,
                    Description: feedback.description,
                    Email: feedback.email,
                    Receive_info: false,
                    Consent: consent,
                    FileNames: filenames,
                    Phone: feedback.Phone,
                    Title: feedback.JobTitle
                }
                //console.log(parameters);
                //if (!submitted){
                appService.submit('/Email/SendFeedbackEmail', parameters)
                    .then(function (data) {
                        if (data == "") {
                            window.location.reload();
                            window.scrollTo(0, 0);
                            window.location.href = "/ThankyouSubscription"
                        }
                    });
                //}
                this.setState({ submitted: true });
                
            }
           
        }
    }
    //Start:Pradip Lalvani -Email    
    handleEmailChange(e) {
        var self = this;
        let errors = {};

        const email = e.target.value

        if (email == "" || email == 'undefined') {
            formIsValid = false;
            this.state.emailError = "Please enter a valid email address";
        }

        if (email != "") {
            this.state.emailError = "";
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(email)) {
                formIsValid = false;
                this.state.emailError = "Please enter valid email-ID.";
            }
            
        }


        self.setState({ errors: errors });
        if (!formIsValid) {
            window.scrollTo({
                behavior: 'smooth',
            });
            return false;
        }
        return true;
    }
    //End:Pradip Lalvani -Email
    validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
    }

    render() {
        const { feedback, submitted } = this.state;
        const meta = {
            title: "Kluwer Law Online - Feedback",
            canonical: window.location.href,
        }
        return (
            <DocumentMeta {...meta}>
            <div className="col-12 klo-shopping-cart">
                    <div className="row">
                        <div className="col-lg-12 margintop">
                            <p style={{ textAlign: 'center' }}>
                                Should you experience access problems, please contact Technical Support in the form below.
                                </p>
                            </div>
                        <div className="col-lg-12 colPadding">
                           
                        <div className="mt-4 font-500">
                                <p className="franziskafont">Feedback & support</p>
                                <p className="PublicationTitle green-heading">Please tell us how we can help you:</p>
                            <p className="BookBody">
                                <div dangerouslySetInnerHTML={{ __html: this.state.content }} />
                            </p>
                            <form name="form" onSubmit={this.handleSubmit}>
                                <div className="row">
                                        <div className="col mr-4">
                                            <div className="form-row mt-3">
                                                <div className="col-lg-4">
                                                    <select className="form-control form-control-sm rounded-0" name="category" value={feedback.category} onChange={this.handleChange}>
                                                        <option style={{ display: 'none' }} selected>I would like to...</option>
                                                        <option>Contact technical support</option>
                                                        <option>Provide some feedback</option>
                                                        <option>Contact customer services</option>
                                                    </select>
                                                    <div className="errorMsg">{this.state.errors.category}</div>
                                                </div>
                                            </div>
                                        <div className="form-row mt-3">
                                            <div className="col-lg-4">
                                                <input type="text" className="form-control form-control-sm rounded-0" placeholder="Message subject"
                                                    name="subject" value={feedback.subject} ref="subject" onChange={this.handleChange} />
                                                <div className="errorMsg">{this.state.errors.subject}</div>
                                            </div>
                                        </div>
                                        <div className="form-row mt-3">
                                            <div className="col-lg-4">
                                                <input type="text" className="form-control form-control-sm rounded-0" placeholder="Product name (optional)"
                                                    name="product" ref="prodName" value={feedback.product} onChange={this.handleChange} />
                                            </div>
                                        </div>

                                        <div className="form-row mt-3">
                                            <div className="col-lg-4">
                                                <div class="uvField" title="How can we help you today?">
                                                    <label class="uvFieldInner" for="Attachment">

                                                        <textarea class="uvFieldTextarea" placeholder="How can we help you today?" name="description" ref="Description" value={feedback.description}
                                                            title="How can we help you today?" value={feedback.description} onChange={this.handleChange}></textarea>
                                                    </label>
                                                    <div class="uvFileAttachments">
                                                        <i class="fa fa-paperclip" aria-hidden="true" style={{ color: 'grey', fontSize: '15px', padding: '3px 12px', float: 'left' }}></i>
                                                        <input type="file" id="file-upload" name="file" onChange={e => this.setFile(e)} multiple />
                                                        <label for="file-upload" style={{ fontSize: '12px', color: '#007AC3', textDecoration: 'underline', cursor: 'pointer' }}>Attach a file</label>
                                                        {this.state.filenames.map((item, index) => {
                                                            return (item + "; ");
                                                        })}
                                                    </div>
                                                  
                                                </div>
                                                <div className="errorMsg">{this.state.errors.description}</div>
                                            </div>
                                        </div>
                                        <br></br>
                                        <p className="PublicationTitle green-heading">Please tell us how we can reach you:</p>
                                        <div className="form-row mt-3">
                                                <div className="col-lg-4">
                                                    <label for="firstname">First name</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" placeholder="First name"
                                                    name="firstname" ref="fName" value={feedback.firstname} onChange={this.handleChange} />
                                                <div className="errorMsg">{this.state.errors.firstname}</div>
                                            </div>
                                            <div className="col-lg-4">
                                                    <label for="lastname">Last name</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" placeholder="Last name"
                                                    name="lastname" ref="lName" value={feedback.lastname} onChange={this.handleChange} />
                                                <div className="errorMsg">{this.state.errors.lastname}</div>
                                            </div>
                                            </div>
                                        <div className="form-row mt-3">
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label for="Email">Email address</label>
                                                    <input type="text" className="form-control" id="email" value={feedback.email} placeholder="Enter your email address"
                                                        name="email" ref="toEmail" onChange={this.handleChange} />
                                                    <div className="errorMsg">{this.state.errors.email}</div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label for="Email">Phone number (optional)</label>
                                                    <input className="form-control" id="Phone" value={feedback.Phone} placeholder="Enter your phone number if you would like to be called"
                                                        name="Phone" ref="Phone" onChange={this.handleChange} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-row mt-3">
                                                <div className="col-lg-4">
                                                    <label for="organization">Organization</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" placeholder="Organization"
                                                    name="organization" ref="org" value={feedback.organization} onChange={this.handleChange} />
                                                <div className="errorMsg">{this.state.errors.organization}</div>
                                            </div>
                                                <div className="col-lg-4">
                                                    <label for="JobTitle">Job title</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" placeholder=""
                                                    name="JobTitle" ref="JobTitle" value={feedback.JobTitle} onChange={this.handleChange} />
                                                <div className="errorMsg">{this.state.errors.JobTitle}</div>
                                            </div>
                                        </div>
                                        <div className="form-row mt-3">
                                                <div className="col-lg-8">
                                                    <label for="country">Country</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" placeholder="Country"
                                                    name="country" ref="country" value={feedback.country} onChange={this.handleChange} />
                                                <div className="errorMsg">{this.state.errors.country}</div>
                                            </div>
                                        </div>
                                        <br></br>
                                        <div className="form-row mt-3">
                                            <div className="col-lg-8">
                                                    <span>If you would like to receive information on relevant products and services from Kluwer Law International, please <a
                                                        Tdata-tooltip="Email opt-in preferences" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLScXXWx4q0pyMxZwOQ5w1DzTRtxJe2MT-wb0vHr2P0MnqkzHDA/viewform">click here</a>.</span>
                                            </div>
                                        </div>
                                        <br></br>
                                       
                                        <div className="form-row mt-3">
                                            <div className="col-lg-8">
                                                <div className="square">
                                                        <input type="checkbox" id="consent" name="consent" value={feedback.consent} onChange={this.handleChange} checked={this.state.consent}/>
                                                    <label for="consent">
                                                        <span className="Searchlabel" style={{ display: 'none' }}>
                                                            I agree to the storage of my email address and name for the purpose of handling my feedback and/or support request. For further privacy details
                                             <a Tdata-tooltip="Personal data processing info" href="http://www.kluwerlaw.com/gdpr/ " target="_blank"> click here</a>.
                                            </span>
                                                    </label>
                                                </div>
                                                <span style={{ display: 'block', paddingLeft: '3%'}}>
                                                    I agree to the storage of my email address and name for the purpose of handling my feedback and/or support request. For further privacy details
                                             <a Tdata-tooltip="Personal data processing info" href="http://www.kluwerlaw.com/gdpr/ " target="_blank"> click here</a>.
                                            </span>
                                                <div className="errorMsg">{this.state.errors.iAgree}</div>
                                            </div>
                                        </div>
                                        <br></br>
                                      
                                    </div>
                                </div>
                                <div className="row mb-5 mt-3 ">
                                    <div className="col">
                                        {/* <a className="btn btn-info next float-left rounded-0" href="/ThankyouSubscription">Send message</a> */}
                                        <button className="btn btn-info next float-left rounded-0">Send message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div> </div> </div>
</DocumentMeta>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/Feedback.jsx